/* Hook encargado de manejar lo referenta a la localizacion
del vehiculo , cliente, sucursal, etc.
Basado en la tabla de regiones (region)
Autor: Benjamín León
Fecha: 2024-08-25
*/
import { useState } from 'react'

import { customFetch } from '../utils/customFetch.ts'
import Region from '../interfaces/Region.ts'

import { makeUrlMunicipalities, makeUrlRegionDetail } from './connectionData.tsx'

const useLocalization = () => {
  const [errorMunicipalities, setErrorMunicipalities] = useState<Error | null>(null)
  const [errorRegion, setErrorRegion] = useState<Error | null>(null)

  const [loading, setLoading] = useState<boolean>(false)

  const fetchMunicipalities = async () => {
    setLoading(true)

    try {
      const apiUrl = makeUrlMunicipalities()
      const data = await customFetch<Region[]>(apiUrl)
      setErrorMunicipalities(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorMunicipalities(err)
      } else {
        setErrorMunicipalities(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }
  const fetchRegionDetail = async (regionId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlRegionDetail(regionId)
      const data = await customFetch<Region>(apiUrl)
      setErrorRegion(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorRegion(err)
      } else {
        setErrorRegion(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return {
    loading,
    errorMunicipalities,
    fetchMunicipalities,
    errorRegion,
    fetchRegionDetail,
  }
}

export default useLocalization
